module.exports = __webpack_public_path__ + "index-banner-new.png?bb54563c514e7dfe6b877bdf5b24c246";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index-banner-new.png
// module id = 89
// module chunks = 0